__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-14-1789393335-stable-dev/";